@if(message !== null) {
  <div>{{ message?.message }}</div>
}
